// PieChart.js
import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Stack } from '@mui/material';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function PieChart({ data, height, width, isDoughnut = false }) {
    const graphOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // Hide legend
                position: 'bottom',
            },
            tooltip: {
                enabled: true,
            },
        },
        // For doughnut chart
        cutout: isDoughnut ? '50%' : 0,
    };

    return (
        <Stack sx={{ width: width, height: height }}>
            <Pie options={graphOptions} data={data} />
        </Stack>
    );
}